export enum Endpoint {
    dashboard = '/dashboard',
    settings = '/settings',
    login = '/login',
    unauthorized = '/unauthorized',
}
